export const APP_NAME = 'capstone';
export default APP_NAME;
